<template>
    <div class="task-results error-results">
        <span v-tooltip.top="task.result.error" class="text-danger err-mar strong">
            Ошибка
        </span>
        <div @click="clickOnShowDetailedTaskInfoIcon"
             class="text-danger icon-err bug"
             v-tooltip.top="'Информация о задаче'">
            <i class="fa fa-info-circle icon"></i>
        </div>
        <div @click="toggleRightSidebarState"
            class="text-danger icon-err"
            v-tooltip.top="'Сообщить об ошибке'">
            <i class="fas fa-bug"></i>
<!--                <svg v-tooltip.top="'Сообщить об ошибке'" width="16px" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="exclamation-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="text-danger padd icon svg-inline&#45;&#45;fa fa-exclamation-circle fa-w-16 fa-7x"><path fill="currentColor" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" class=""></path></svg>-->
        </div>
    </div>
</template>

<script>
export default {
  name: "ErrorResults",
  props: ['task'],
  methods: {
    toggleRightSidebarState() {
      this.$store.commit('toggleSidebarState')
    },
    clickOnShowDetailedTaskInfoIcon() {
      this.$emit('click-on-show-detailed-task-info-icon', this.task)
    },
  }
}
</script>

<style scoped lang="sass">
    .icon
        color: #636363
        text-align: center
        margin: 0 gridSteps(1) 0 gridSteps(1.5)
        width: 24px
        &:hover
            color: #5CA5D4
            cursor: pointer

    .icon-err i
        color: #a94442
        width: 16px
        height: 19px
        text-align: center
        margin: 0 gridSteps(1) 0 gridSteps(1)
        &:hover
           color: #6e1904
           cursor: pointer

    .error-results
        display: flex
        height: 24px
        flex-shrink: 0
        svg
            width: 16px
            path
                 fill: #a94442 !important
            &:focus
                outline: none
        svg
             &:hover
                 cursor: pointer
                 path
                     fill: currentColor

        svg
            &:hover
                path
                    fill: #5CA5D4

    .text-danger
        &:hover
            text-decoration: underline


    .err-mar
        margin-right: gridSteps(3)

    .bug
        margin-right: 12px




</style>
